import * as React from "react"
import { NavLink } from "react-router-dom"
import { pretty_date } from "../../../../utils"
import { link, linkWrapper } from "../../../cms/blocks/utils.gen"
import { get_lang_from_url } from "../../../map/maps_utils"
import { WordPress } from "../../../wordpress/wordpress_api"
import { loader } from "../../templates/loader.mod"
import i18next from "i18next"



interface Props {
    events: WordPress.PostTypeResponse[]
    isLoading: boolean
}

export const EventOverviewLayout = (props: Props) => {
    let lang = get_lang_from_url(_ => "")
    return (
      <section className="block block--listing lst">
        <div className="lst__inner container container--s gutter--m spacing--m">
          {!props.isLoading && props.events.length > 0 && (
            <ul className="lst__list">
              {props.events.map((event) => (
                <li className="lst__item" key={event.id}>
                  <NavLink className="lst__link" to={`${lang}/events/${event.slug}/`}>
                    <time className="lst__date typo--s" dateTime={pretty_date((event.acf as any)?.event_date)}>{pretty_date((event.acf as any)?.event_date)}</time>
                    <h3 className="lst__title ff--primary typo--ml">{event.title.rendered}</h3>
                  </NavLink>
                  {(event.acf as any)?.event_url && link(linkWrapper({title: '', url: (event.acf as any)?.event_url}), {classname: 'button button--primary'}, (event.acf as any)?.link_label)}

                </li>
              ))}
            </ul>
          )}

          {props.isLoading && loader.run(undefined)}

          {!props.isLoading && props.events.length == 0 && <h3 className="lst__title ff--primary typo--ml">{i18next.t("publication.nadaa")}</h3>}
        </div>
      </section>
    )
}